import styled from 'styled-components';

export const Container = styled.div`
  width: 150px;
`;

export const Description = styled.div`
  margin-top: 10px;
`;
